/* EB collection: collapsible filter facets (headers are plain <p>, wire them as toggles) */
(function(){
  function bind(){
    var heads = document.querySelectorAll('.collection-sidebar__group > p.lg, #CollectionSidebar .collection-sidebar__group p.lg, #SidebarDrawer .collection-sidebar__group p.lg');
    heads.forEach(function(h){
      if(h.dataset.ebBound) return;
      h.dataset.ebBound = '1';
      var group = h.closest('.collection-sidebar__group');
      if(!group) return;
      var content = group.querySelector('.collapsible-content--sidebar');
      h.setAttribute('role','button');
      h.setAttribute('tabindex','0');
      function toggle(){
        if(!content) return;
        var collapsed = group.classList.toggle('eb-collapsed');
        if(collapsed){ content.classList.remove('is-open'); content.style.height='0px'; }
        else { content.classList.add('is-open'); content.style.height='auto'; }
      }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function(e){ if(e.key==='Enter' || e.key===' '){ e.preventDefault(); toggle(); } });
    });
  }

  function relocateActiveFilters(){
    var title = document.querySelector('.section-header--flush') || document.querySelector('.collection-hero') || document.querySelector('main h1');
    if(!title) return;
    var anchor = title.closest('.section-header') || title;
    var host = document.getElementById('eb-active-filters');
    if(!host){ host=document.createElement('div'); host.id='eb-active-filters'; anchor.parentNode.insertBefore(host, anchor.nextSibling); }
    var at = document.querySelector('.collection-sidebar .tag-list--active-tags') || document.querySelector('.tag-list--active-tags:not(#eb-active-filters *)');
    if(at && !host.contains(at)){ host.innerHTML=''; host.appendChild(at); }
    var hostAt = host.querySelector('.tag-list--active-tags') || at;
    if(hostAt){ hostAt.querySelectorAll('.tag--remove').forEach(function(t){ if(!t.querySelector('.eb-x')){ var s=document.createElement('span'); s.className='eb-x'; s.textContent='\u2715'; var a=t.querySelector('a'); if(a){ a.appendChild(s); } } }); }
  }


  // Sort placement/dedupe now owned by #eb-mobile-filter-sort-inline in theme.liquid
  // (viewport-aware; this used to also relocate unconditionally and fought that logic
  // on mobile, plus never cleaned up the duplicate #SortBy left behind by AJAX reloads).

  function init(){ bind(); relocateActiveFilters(); }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', function(){ bind(); relocateActiveFilters(); });
  // Impulse re-renders the grid/filters via AJAX on filter change
  document.addEventListener('collection:reloaded', function(){ bind(); relocateActiveFilters(); });
  document.addEventListener('shopify:section:load', function(){ bind(); relocateActiveFilters(); });
})();
